// Values for the organizationPreference.gmailSyncEnabledFor enum
// (mirrors the oap-api GmailSyncEnabledFor enum).
export const GMAIL_SYNC_ALL_MEMBERS = 'all_members'
export const GMAIL_SYNC_NO_ONE = 'no_one'
